module.exports = __webpack_public_path__ + "img/EventWinPage0108.f8716622.png";